<template>
  <div>
    <a-collapse accordion v-model="activeKey">
      <a-collapse-panel header="Reconocimiento" key="1">
        <a-card title="Filtro por Fecha Creación" size="small" v-if="mostrarFiltro === 'SI'">
          <a-form-model :model="filterParams" v-bind="fiOptionsFilter" ref="filterForm">
            <a-row>
              <a-col v-bind="colSpanFilter">
                <a-form-model-item :label="$t('Fecha Desde')" prop="year" has-feedback
                                   :rules="[{ required: false, message: 'Valor requerido' }]">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD"
                                 v-model="filterParams.fecha_desde"/>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpanFilter">
                <a-form-model-item :label="$t('Fecha Hasta')" prop="year" has-feedback
                                   :rules="[{ required: false, message: 'Valor requerido' }]">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD"
                                 v-model="filterParams.fecha_hasta"/>
                </a-form-model-item>
              </a-col>
              <a-col v-bind="colSpanFilter">
                <a-form-model-item :wrapper-col="{ span: 16 }">
                  <a-button type="primary" @click="filtrar">Filtrar</a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-card>
        <br>
        <g-master name="reconocimiento"
                  :endpoint="reconocimiento.endpoint"
                  :tableSetup="reconocimiento.tableSetup"
                  @action="reconocimientoAction"
                  @handleOk="handleOk"
                  ref="masterComponent"
                  :modalFieldsSetup="reconocimiento.modalFieldsSetup"
                  :parentData="filterParams">
                <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag :color="getColor(text)">{{getValueApproval(text)}}</a-tag>
                </span>
                <span slot="estadoRecoRenderer" slot-scope="{text}">
                        <a-tag :color="getColor1(text)">{{getValueApproval1(text)}}</a-tag>
                </span>
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in reconocimiento.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
          <template slot="masterModal" slot-scope="{record}">

            <a-row :gutter="[16,16]">
              <a-col>
                <g-lookup label="Empleado"
                          :formItemConfig="reconModal.fiOptions"
                          endpoint="empleados"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="paramsEmpleadoActivo"
                          :selectedObj.sync="id_emp_selected"
                          ref="empleado">
                </g-lookup>
              </a-col>
              <a-col>
                <a-form-item v-bind="reconModal.fiOptions" :label="$t('Fecha evento')">
                  <a-date-picker style="width: 100%"
                                 v-decorator="['application_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-if="mostrarCampoAnio">
                <a-form-item :label="$t('Año')" v-bind="reconModal.fiOptions">
                  <a-select v-decorator="['year', { rules: [
                            { required: true, message: 'Valor requerido' },
                           ] }]" style="width: 100%">
                    <a-select-option v-for="year_ in years" :key="year_">
                      {{ year_ }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col v-if="mostrarCampoMes">
                <a-form-item :label="$t('Mes')" v-bind="reconModal.fiOptions">
                  <a-select v-decorator="['month', { rules: [
                            { required: true},
                           ] }]" style="width: 100%">
                    <a-select-option v-for="month_ in months_name" :key="month_.value">
                      {{ month_.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col>
                <g-dropdown endpoint="hierarchy_lookup"
                            :label="$t('Tipo Reconocimiento')"
                            :formItemConfig="reconModal.fiOptions"
                            :selectedObj.sync="recognition_type_selected"
                            :decorator="['recognition_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="reconModal.requestData.recognition_type"></g-dropdown>
              </a-col>
              <a-col>
                <g-dropdown endpoint="hierarchy_lookup"
                            :label="$t('Tipo Periodo')"
                            v-if="oculta_campos"
                            :formItemConfig="reconModal.fiOptions"
                            :decorator="['period_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="reconModal.requestData.period_type"
                            :selectedObj.sync="reconModal.period_type_selected"
                            ref="period_type"></g-dropdown>
              </a-col>
              <a-col>
                <g-dropdown
                  :label="$t('Sub Periodo')"
                  :formItemConfig="reconModal.fiOptions"
                  v-if="oculta_campos"
                  endpoint="hierarchy_lookup_domains"
                  :decorator="['sub_period', { rules: [{ required: reconModal.period_type_selected.equivalency !== 'ANU', message: 'Valor requerido' }]}]"
                  :params="sub_period_params"
                  :disabled="reconModal.period_type_selected.equivalency === 'ANU'">
                </g-dropdown>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-collapse-panel>
      <a-collapse-panel header="Detalle" key="2" :disabled="!reconocimientoSeleccionado.id_recognition">
        <a-card hoverable>
          <a-card-meta :title="reconocimientoSeleccionado.id_emp_name">
            <a-avatar
              slot="avatar"
              :src="profileSrc"
            />
          </a-card-meta>
          <br>
          <a-alert
            :message="getValueApproval(reconocimientoSeleccionado.approval)"
            :type="getType(reconocimientoSeleccionado.approval)"
            show-icon
          >
                <span slot="description" v-html="getDescription()">

                </span>
          </a-alert>
        </a-card>
        <a-tabs defaultActiveKey="1">
          <a-tab-pane :tab="$t('Perfil Empresa')" key="1">
            <g-master v-bind="configMasterPerfilEmpresa"
                      :parentData="perfilEmpresaRequest()"
                      :key="key"
            >
              <template slot="masterModal" slot-scope="{record}">
                <a-row :gutter="[16,16]">
                  <a-col>
                    <g-dropdown endpoint="hierarchy_lookup"
                                :label="$t('Competencia')"
                                :formItemConfig="reconModal.fiOptions"
                                :decorator="['id_h_competency', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                                :params="detalles.perfilEmpresaModal.competenciaRequest"></g-dropdown>
                  </a-col>
                  <a-col>
                    <a-form-item v-bind="reconModal.fiOptions" :label="$t('Observaciones')">
                      <a-textarea style="width: 100%"
                                  v-decorator="['comments', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col>
                    <a-form-item v-if="oculta_campos" v-bind="reconModal.fiOptions"
                                 :label="$t('Otros aspectos a resaltar')">
                      <a-textarea style="width: 100%"
                                  v-decorator="['other_aspects', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col>
                    <a-form-item v-if="oculta_campos" v-bind="reconModal.fiOptions"
                                 :label="$t('Aportes significativos')">
                      <a-textarea style="width: 100%"
                                  v-decorator="['featured_actions', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </template>
            </g-master>
          </a-tab-pane>
          <a-tab-pane :tab="$t('Perfil Productivo')" key="2" v-if="oculta_campos">
            <g-master name="perfilProductivo"
                      :endpoint="detalles.perfilProductivo.endpoint"
                      :tableSetup="detalles.perfilProductivo.tableSetup"
                      ref="perfilProductivo"
                      :modalFieldsSetup="detalles.perfilProductivo.modalFieldsSetup"
                      :parentData="perfilProductivoRequest()">
              <template slot="masterModal" slot-scope="{record}">
                <a-row :gutter="[16,16]">
                  <a-col>
                    <a-form-item v-bind="reconModal.fiOptions" :label="$t('Promedio trimestral')">
                      <a-textarea style="width: 100%"
                                  v-decorator="['quarterly_average', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                  <a-col>
                    <a-form-item v-bind="reconModal.fiOptions" :label="$t('Aspectos técnicos')">
                      <a-textarea style="width: 100%"
                                  v-decorator="['technical_aspects', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                    </a-form-item>
                  </a-col>
                </a-row>
              </template>
            </g-master>
          </a-tab-pane>
        </a-tabs>
      </a-collapse-panel>
    </a-collapse>
    <modal-aprobacion-reconocimiento ref="modalAproRec" @handleOk="loadData"/>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    components: {ATextarea},
    data () {
      return {
        mostrarFiltro: this.$getConfigValue('RECONOCIMIENTOS_INDV_FILTRO_FECHA', null),
        mostrarCampoAnio: this.$getConfigValue('MOSTRAR_ANIO_MODAL_RECONOCIMIENTOS') !== 'NO',
        mostrarCampoMes: this.$getConfigValue('MOSTRAR_MES_MODAL_RECONOCIMIENTOS') !== 'NO',
        filterParams: {
          fecha_desde: null,
          fecha_hasta: null
        },
        fiOptionsFilter: {
          'label-col': {span: 8},
          'wrapper-col': {span: 12}
        },
        colSpanFilter: {
          xs: 16,
          md: 6
        },
        loadingBtns: {},
        key: 0,
        configMasterPerfilEmpresa: {},
        months_name: [
          {name: 'Enero', value: '1'},
          {name: 'Febrero', value: '2'},
          {name: 'Marzo', value: '3'},
          {name: 'Abril', value: '4'},
          {name: 'Mayo', value: '5'},
          {name: 'Junio', value: '6'},
          {name: 'Julio', value: '7'},
          {name: 'Agosto', value: '8'},
          {name: 'Septiembre', value: '9'},
          {name: 'Octubre', value: '10'},
          {name: 'Noviembre', value: '11'},
          {name: 'Diciembre', value: '12'}
        ],
        years: [],
        yearToday: parseInt(moment().format('YYYY')),
        oculta_campos: this.$getConfigValue('RECONOCIMIENTO_OCULTA_CAMPOS', 'NO') === 'NO',
        activeKey: 1,
        defaultPicture: require('./../../../assets/anon_profile.png'),
        profileSrc: require('./../../../assets/anon_profile.png'),
        reconocimientoSeleccionado: {},
        reconocimiento: {
          valoresExpandidos: [
            {label: 'Cargo', column: 'cargo'},
            {label: 'Grupo', column: 'h_att_1'},
            {label: 'Puesto', column: 'h_att_2'},
            {label: 'Personal', column: 'h_category'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'gestion_humana/reconocimiento',
          tableSetup: {
            customSlots: ['expandedRowRender', 'estadoRenderer', 'estadoRecoRenderer'],
            columns: [],
            actions: {
              title: 'Acciones',
              scopedSlots: {customRender: 'hooverableAction'},
              width: 150,
              fixed: 'right',
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return this.allowDeleteEdit(record)
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return this.allowDeleteEdit(record)
                  }
                },
                {
                  name: 'detalles',
                  text: 'Detalles',
                  icon: 'search',
                  props: {size: 'small', type: 'link', icon: 'search', style: 'color:green;'}
                },
                {
                  name: 'aprobar',
                  text: 'Aprobar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnVisible: (record) => {
                    return this.allowRol(record)
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  icon: 'close',
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color:red;'},
                  fnVisible: (record) => {
                    return this.allowRol(record)
                  }
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'file-pdf', style: 'color: red'},
                  fnVisible: (record) => {
                    let conf = typeof this.$getConfigValue('REPORTES_RECONOCIMIENTO_CARTA', false)
                    if (!(conf === 'boolean') && record.approval == 1) {
                      return this.allowRolDowndloadPdf()
                    }
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_recognition] === record.id_recognition
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_recognition'
            },
            requestData: {}
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'year'},
            {name: 'month'},
            {name: 'recognition_type'},
            {name: 'period_type'},
            {name: 'sub_period'},
            {name: 'application_date', type: 'date'}
          ]
        },
        reconModal: {
          fiOptions: {
            'label-col': {span: 8},
            'wrapper-col': {span: 16},
            'has-feedback': true
          },
          requestData: {
            recognition_type: {h_lookup_type: 'TIPO_RECONOCIMIENTO', use_code: true},
            period_type: {h_lookup_type: 'TIPO_PERIODO'}
          },
          period_type_selected: {}
        },
        detalles: {
          perfilEmpresa: {
            endpoint: 'gestion_humana/recon_company',
            tableSetup: {
              columns: [
                {title: 'Competencia', dataIndex: 'desc_competencia', sorter: true},
                {title: 'Observaciones', dataIndex: 'comments', sorter: true},
                {title: 'Otros aspectos a resaltar', dataIndex: 'other_aspects', sorter: true},
                {title: 'Aportes significativos', dataIndex: 'featured_actions', sorter: true}
              ],
              tableConfig: {
                rowKey: 'id'
              }
            },
            modalFieldsSetup: [
              {name: 'id_h_competency'},
              {name: 'comments'},
              {name: 'other_aspects'},
              {name: 'featured_actions'}
            ]
          },
          perfilProductivo: {
            endpoint: 'gestion_humana/recon_productive',
            tableSetup: {
              columns: [
                {title: 'Promedio trimestral', dataIndex: 'quarterly_average', sorter: true},
                {title: 'Aspectos técnicos', dataIndex: 'technical_aspects', sorter: true}
              ],
              tableConfig: {
                rowKey: 'id_productive'
              }
            },
            modalFieldsSetup: [
              {name: 'quarterly_average'},
              {name: 'technical_aspects'}
            ]
          },
          perfilEmpresaModal: {
            competenciaRequest: {h_lookup_type: 'COMPETENCIAS'}
          }
        },
        paramsEmpleadoActivo: {
          estado_activo: true
        },
        id_emp_selected: {},
        recognition_type_selected: {}
      }
    },
    created () {
      this.clearColumn()
      this.configMasterPerfilEmpresa = {
        name: 'perfilEmpresa',
        endpoint: this.detalles.perfilEmpresa.endpoint,
        tableSetup: this.detalles.perfilEmpresa.tableSetup,
        ref: 'perfilEmpresa',
        modalFieldsSetup: this.detalles.perfilEmpresa.modalFieldsSetup
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.yearsSelect()
    },
    methods: {
      allowDeleteEdit (record) {
        if (this.$getConfigValue('VALIDAR_ACCION_EDITAR_ELIMINAR_RECO', 'NO') === 'SI') {
          return this.$isEmpty(record.approval) && this.$isEmpty(record.status_rec) && ((this.$store.state.userInfo.name === record['created_by'] && this.$userIsInrol('CREA_RECONI')) || this.$userIsInrol('ADM_RECONI'))
        } else {
          return this.$isEmpty(record.approval) && this.$store.state.userInfo.name === record['created_by']
        }
      },
      allowRol (record) {
        if (this.$getConfigValue('VALIDAR_ACCIONES_ESTADO_RECON_CERRADO', 'NO') === 'SI') {
          return this.$isEmpty(record.approval) &&
            this.$isEmpty(record.status_rec) &&
            (this.$userIsInrol('RECONOCIMIENTO') || this.$userIsInrol('HRReq') || this.$userIsInrol('APR_DIRRECONI') || this.$userIsInrol('ADM_RECONI'))
        } else {
          return record.approval == null && (this.$userIsInrol('RECONOCIMIENTO') || this.$userIsInrol('HRReq') || this.$userIsInrol('APR_DIRRECONI') || this.$userIsInrol('ADM_RECONI'))
        }
      },
      allowRolDowndloadPdf () {
        return (this.$userIsInrol('HRReq') || this.$userIsInrol('CoordReconocimiento') || this.$userIsInrol('CREA_RECONI') || this.$userIsInrol('ADM_RECONI'))
      },
      clearColumn () {
        this.reconocimiento.tableSetup.columns = [
          {title: 'ID Recon.', dataIndex: 'id_recognition', sorter: true, width: 120},
          {title: this.$t('Fecha evento'), dataIndex: 'application_date_desc', sorter: true, width: 200},
          {title: 'Id. Emp', dataIndex: 'id_emp', sorter: true},
          {title: 'Empleado', dataIndex: 'id_emp_name', sorter: true},
          {title: 'Compañia', dataIndex: 'company_name', sorter: true},
          {title: 'Año', dataIndex: 'year', sorter: true},
          {title: 'Mes', dataIndex: 'mes', sorter: true},
          {title: 'Tipo Reconocimiento', dataIndex: 'recognition_type_name', sorter: true},
          {
            title: 'Aprobación',
            dataIndex: 'approval',
            sorter: true,
            width: 135,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'estadoRenderer'
            }
          },
          {title: 'Comentarios', dataIndex: 'comments', sorter: true},
          {title: 'Periodo', dataIndex: 'period_type_name', sorter: true},
          {title: 'Sub Periodo', dataIndex: 'sub_period_name', sorter: true},
          {title: 'Tipo Entregable', dataIndex: 'deliverable_type_name', sorter: true},
          {title: 'Fecha Entrega', dataIndex: 'delivery_date_desc', sorter: true}
        ]
        if (!this.oculta_campos) {
          this.reconocimiento.tableSetup.columns.splice(9, 12)
          this.reconocimiento.tableSetup.columns.push(
            {
              title: this.$getConfigValue('NOMBRE_CAMPO_F_SOLIC_RECONOC', 'Fecha de solicitud'),
              dataIndex: 'approval_date_desc',
              sorter: true
            }
          )
          this.reconocimiento.tableSetup.columns.push(
            {
              title: 'Estado',
              dataIndex: 'status_rec',
              sorter: true,
              scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'estadoRecoRenderer'
              }
            }
          )
          this.detalles.perfilEmpresa.tableSetup.columns.splice(2, 3)
        }
      },
      yearsSelect () {
        for (let i = this.yearToday - 1; i <= (this.yearToday + 5); i++) {
          this.years.push(i)
        }
      },
      loadData () {
        this.reconocimientoSeleccionado = {}
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      },
      getValueApproval (text) {
        switch (text) {
          case null:
          case undefined:
            return 'EN PROCESO'
          case 'N':
          case '0':
            return 'RECHAZADA'
          case 'S':
          case '1':
            return 'APROBADA'
        }
      },
      getColor (text) {
        switch (text) {
          case null:
            return 'blue'
          case 'N':
          case '0':
            return 'red'
          case 'S':
          case '1':
            return 'green'
        }
      },
      getValueApproval1 (text) {
        switch (text) {
          case null:
          case undefined:
            return ' '
          case 'CERRADO':
            return 'CERRADO'
        }
      },
      getColor1 (text) {
        switch (text) {
          case null:
            return 'white'
          case 'CERRADO':
            return 'red'
        }
      },
      getType (text) {
        switch (text) {
          case null:
          case undefined:
            return 'info'
          case 'N':
          case '0':
            return 'error'
          case 'S':
          case '1':
            return 'success'
        }
      },
      reconocimientoAction (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
            })
            break
          case 'fieldsChange':
            if (!JsUtils.isEmpty(action.changedFields.period_type)) {
              this.$refs.period_type && this.$refs.period_type.handleChange(action.changedFields.period_type.value)
            }
            break
          case 'detalles':
            this.activeKey = 2
            this.seleccionarReconocimiento(action.record)
            break
          case 'aprobar':
            this.getCompetencias(action, action.record)
            break
          case 'rechazar':
            this.gestionApproval(action, 0)
            break
          case 'download':
            this.downloadFile(action.record)
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id_recognition] = record.id_recognition
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('recognition/download', {
          params: {
            id_recognition: record.id_recognition
          }
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id_recognition', 'file_link_elm')
            document.body.appendChild(fileLink)
          }
          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id_recognition]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      gestionApproval (action, approval) {
        this.$refs.modalAproRec && this.$refs.modalAproRec.showModal(
          {
            record: action.record,
            oculta_campos: this.oculta_campos,
            approval
          }
        )
      },
      seleccionarReconocimiento (recon) {
        this.reconocimientoSeleccionado = recon
        this.loadEmployPicture(this.reconocimientoSeleccionado.id_person)
      },
      loadEmployPicture (idPerson) {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + idPerson, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
      },
      getDescription () {
        if (this.reconocimientoSeleccionado.comments) {
          return `
              <strong>Reconocimiento:</strong> ${this.reconocimientoSeleccionado.recognition_type_name}
              <br>
              <strong>Comentario:</strong> ${this.reconocimientoSeleccionado.comments}
              `
        } else {
          return `
              <strong>Reconocimiento:</strong> ${this.reconocimientoSeleccionado.recognition_type_name}
              `
        }
      },
      handleOk (item) {
        this.reconocimientoSeleccionado.id_recognition = item.id_recognition
        this.reconocimientoSeleccionado.comments = item.comments
        this.reconocimientoSeleccionado.id_emp_name = this.id_emp_selected.nombre
        this.reconocimientoSeleccionado.recognition_type_name = this.recognition_type_selected.text
        this.loadEmployPicture(item.id_emp)

        setTimeout(() => { this.activeKey = 2 }, 500)
      },
      perfilEmpresaRequest () {
        return {
          id_recognition: JsUtils.isEmpty(this.reconocimientoSeleccionado.id_recognition) ? '-1' : this.reconocimientoSeleccionado.id_recognition
        }
      },
      perfilProductivoRequest () {
        return {
          id_recognition: JsUtils.isEmpty(this.reconocimientoSeleccionado.id_recognition) ? '-1' : this.reconocimientoSeleccionado.id_recognition
        }
      },
      getCompetencias (action, recon) {
        this.reconocimientoSeleccionado = recon
        this.httpClient.getInstance().get('gestion_humana/recon_compan/consultarCompetencias/' + this.reconocimientoSeleccionado.id_recognition)
          .then(response => {
            if (response.data === 1) {
              this.gestionApproval(action, 1)
              this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
            } else {
              this.$confirm({
                title: 'No es posible aprobar el reconocimiento.',
                content: 'Esta persona no tiene competencias creadas, por favor ingrese al detalle del reconocimiento y cree una Competencia para el empleado',
                onOk () {},
                onCancel () {}
              })
            }
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible verificar si el empleado ya tiene una competencia creada para este reconocimiento.')
          })
      },
      filtrar () {
        if (!this.$isEmpty(this.filterParams.fecha_desde) && !this.$isEmpty(this.filterParams.fecha_hasta)) {
          this.filterParams = {
            fecha_desde: this.filterParams.fecha_desde,
            fecha_hasta: this.filterParams.fecha_hasta
          }
        }
      }
    },
    computed: {
      sub_period_params () {
        return {h_lookup_domain: this.reconModal.period_type_selected.equivalency, use_code: true}
      },
      getStatus () {
        return this.reconocimientoSeleccionado.id_recognition
      }
    },
    watch: {
      getStatus () {
        if (this.reconocimientoSeleccionado.approval != null) {
          this.$set(this.configMasterPerfilEmpresa, 'actions', false)
          this.detalles.perfilEmpresa.tableSetup.actions = false
          this.key++
        } else {
          this.$delete(this.configMasterPerfilEmpresa, 'actions')
          this.detalles.perfilEmpresa.tableSetup.actions = true
          this.key--
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Reconocimiento/Reconocimiento.vue